module.exports = __webpack_public_path__ + "static/media/R-150XLHD_CrossSection.a1263be7.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/es/R-150XLHD_CrossSection.png
// module id = 484
// module chunks = 0